import { Box } from '@rbilabs/universal-components';

import { theme } from 'styles/configure-theme';

export const HeroSection = Box.withConfig<{ $reversed: boolean }>(p => ({
  background: p.$reversed ? theme.token('background-hero-reversed') : 'transparent',
}));
